/**
 * The last grooming project the person had open on this computer (epic
 * PI-SPEC-SW-E292, feature PI-SPEC-SW-1495; UX-PM-17 in
 * docs/analysis/toolbox-ux/03-evaluation.md, Claude Design frame D5).
 *
 * The project lives in the path (`/grooming/<project>/...`), so a page
 * without one (Toolbox home, the Queue) does not know it. The Toolbox frame
 * (in the app) and the grooming layout (in a browser) write it whenever a
 * `/grooming/<project>` page is shown; Toolbox home and the command palette
 * read it there. Per computer, like the backlog sort, so localStorage is the
 * right scope. Storage errors (private mode, quota) are swallowed: a project
 * that is not remembered only means home and the palette have none.
 */

/** localStorage key of the remembered project. */
export const LAST_PROJECT_STORAGE_KEY = "spectree.grooming.lastProject";

/** The remembered project, or undefined when none is stored or storage is unavailable. */
export function readLastProject(): string | undefined {
  try {
    const stored = window.localStorage.getItem(LAST_PROJECT_STORAGE_KEY)?.trim();
    if (!stored) return undefined;
    return stored;
  } catch {
    return undefined;
  }
}

/** Remember the project; a blank name is ignored and a storage failure only means it is not remembered. */
export function writeLastProject(project: string): void {
  const name = project.trim();
  if (name.length === 0) return;
  try {
    if (window.localStorage.getItem(LAST_PROJECT_STORAGE_KEY) === name) return;
    window.localStorage.setItem(LAST_PROJECT_STORAGE_KEY, name);
  } catch {
    // Not remembered; the page still shows the project for this visit.
  }
}
